import { UseMutationResult, useMutation, useQueryClient } from "react-query";

import { useAuth } from "../../sdk/hooks";
import { api } from "../../sdk/utils";

export interface IDeleteReelMutationParameters {
    reelId: string;
    variantId: string;
    productId: string;
}

export const useDeleteReel = (
    invalidQueryKeys: string | string[],
): UseMutationResult<void, unknown, IDeleteReelMutationParameters> => {
    const auth = useAuth();
    const queryClient = useQueryClient();

    return useMutation<void, unknown, IDeleteReelMutationParameters>({
        mutationFn: async (parameters: IDeleteReelMutationParameters) => {
            if (!auth.token) {
                throw new Error("Cannot delete reel without authorization token.");
            }

            return await api.Products.deleteReel(
                parameters.reelId,
                parameters.variantId,
                parameters.productId,
                auth.token
            );
        },
        onSuccess: () => {
            queryClient.invalidateQueries(invalidQueryKeys);
        },
    });
};
